import {Button, Modal} from 'react-bootstrap';
import React from 'react';
import AssetSelector from './AssetSelector';

class AssetSelectModal extends React.Component {
  constructor(props) {
    super(props);

    this.handleFileChange = this.handleFileChange.bind(this);
    this.fileRef = React.createRef();
  }

  handleFileChange() {
    if (!this.fileRef.current.files.length) {
      return;
    }

    const file = this.fileRef.current.files[0];
    this.props.onFileSelected(file);
  }

  render() {
    let typeString = 'Velg et bilde';
    let typeString2 = 'Last opp annet bilde';
    let accept = 'image/*';

    if (this.props.isVideo) {
      typeString = 'Velg en video';
      typeString2 = 'Last opp annen video';
      accept = 'video/*';
    }

    return (
      <div>
        <Modal
          bsSize="large"
          show={this.props.show}
          backdrop={true}
          onHide={this.props.onHide}
        >
          <Modal.Header closeButton={true}>
            <Modal.Title>{typeString}</Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <AssetSelector isVideo={this.props.isVideo} onSelect={this.props.onSelect}/>
          </Modal.Body>

          <Modal.Footer>
            {this.props.onFileSelected &&
              <label className="pull-left btn btn-default">
                <input type="file" className="hidden" ref={this.fileRef} onChange={this.handleFileChange} accept={accept} />
                <span>{typeString2}</span>
              </label>
            }
            <Button
              bsStyle="primary"
              onClick={this.props.onHide}
            >
                Avbryt
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

AssetSelectModal.defaultProps = {
  show: true
};

export default AssetSelectModal;
